export default "__VITE_PUBLIC_ASSET__2a0438c7__"